import useAuthState from '@/states/auth.state';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { initKeycloak, isKeycloakReady, isAuthenticated } from '@/utils/auth/keycloak-instance';

export const Login: React.FC = () => {
  const { handleLogin } = useAuthState();
  const [searchParams] = useSearchParams();
  const tenantId = searchParams.get('tenantId');
  const [isInitializing, setIsInitializing] = useState(false);

  useEffect(() => {
    const initAuth = async () => {
      if (isInitializing) return;
      setIsInitializing(true);

      try {
        // Check if Keycloak is already initialized and user is authenticated
        if (isKeycloakReady() && isAuthenticated()) {
          console.log('Already authenticated, redirecting to workspace');
          globalThis.location.href = tenantId ? `/${tenantId}` : '/workspaces';
          return;
        }

        // Clean up old auth data for fresh login
        console.log('Cleaning up old auth data for fresh login...');
        localStorage.removeItem('initial-tenant-id');
        localStorage.removeItem('auth-storage');
        localStorage.removeItem('auth-token');
        localStorage.removeItem('auth-refresh-token');
        localStorage.removeItem('current-tenant-storage');
        localStorage.removeItem('processes-storage');
        localStorage.removeItem('keycloak-auth');

        if (tenantId) {
          localStorage.setItem('initial-tenant-id', tenantId);
        }

        // Initialize Keycloak
        const authenticated = await initKeycloak(
          () => {
            console.log('Keycloak authenticated successfully');
            globalThis.location.href = tenantId ? `/${tenantId}` : '/workspaces';
          },
          (error) => {
            console.error('Keycloak initialization error:', error);
          },
        );

        if (!authenticated) {
          // Not authenticated, start login flow
          await handleLogin();
        } else if (tenantId) {
          globalThis.location.href = `/${tenantId}`;
        }
      } catch (error) {
        console.error('Error initializing Keycloak:', error);
        await handleLogin();
      } finally {
        setIsInitializing(false);
      }
    };

    initAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      Authenticating with Keycloak...
    </div>
  );
};
